import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { UnauthorizedAccessComponent } from '../modules/Platform/Configuration/admin-settings/unauthorized-access/unauthorized-access.component';
import { ApprovalRequestComponent } from '../modules/Platform/Configuration/admin-settings/approval-request/approval-request.component';

const CALLBACK_PATH = 'login/callback';
const routes: Routes = [
  { path: 'request-approval/:id', component: ApprovalRequestComponent },
  { path: CALLBACK_PATH, component: OktaCallbackComponent },
  {
    path: '',
    loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule)
  },
  { path: '_admin', loadChildren: () => import('../modules/Platform/Auth/auth.module').then(m => m.AuthModule)},
  { path: 'access-denied', component: UnauthorizedAccessComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
